import React from 'react';
import proptypes from 'prop-types';
import { DisplayHeader } from './Typography';
import UnderscoreDivider from './UnderscoreDivider';

const PageHeading = ({ title, description }) => (
  <div className="row mb-4 mb-lg-5">
    <div className="col">
      <DisplayHeader>{title}</DisplayHeader>
      <UnderscoreDivider />
    </div>
    {description && (
      <div className="col-md">
        {description}
      </div>
    )}
  </div>
);

PageHeading.defaultProps = {
  description: '',
};

PageHeading.propTypes = {
  title: proptypes.string.isRequired,
  description: proptypes.node,
};

export default PageHeading;
